import { memo, useCallback, useRef } from 'react'

import * as Styled from './styled'

import { Text } from 'common-components'
import {
  useScrollToneOptionIntoView,
  useToneOptionScrollHandler
} from './hooks'
import ArrowScrollButton from './ArrowScrollButton'
import { TScrollDirection, scrollElementToPosition } from './utils'
import { ITtsSpeakerTone } from 'types/text-to-speech'

interface IVoiceToneTagsProps {
  onToneChange?: (tone: ITtsSpeakerTone) => void
  selectedTone?: ITtsSpeakerTone | null
  toneTags: ITtsSpeakerTone[]
}

const VoiceToneTags: React.FC<IVoiceToneTagsProps> = ({
  onToneChange,
  toneTags,
  selectedTone
}) => {
  const scrollRef = useRef<HTMLDivElement>(null)

  const { showLeftArrow, showRightArrow, handleScroll } =
    useToneOptionScrollHandler(scrollRef)
  const scrollToneOptionIntoView = useScrollToneOptionIntoView(scrollRef)

  const scrollToPosition = useCallback((direction: TScrollDirection) => {
    scrollElementToPosition(direction, scrollRef.current)
  }, [])

  const handleToneSelect = useCallback(
    (tone: ITtsSpeakerTone) => {
      onToneChange?.(tone)
      scrollToneOptionIntoView(tone.id)
    },
    [onToneChange, scrollToneOptionIntoView]
  )

  return (
    <Styled.ScrollContainer>
      <ArrowScrollButton
        direction="left"
        onClick={() => scrollToPosition('left')}
        isVisible={showLeftArrow}
      />

      <Styled.TonesWrapper ref={scrollRef} onScroll={handleScroll}>
        {toneTags.map((tone: ITtsSpeakerTone) => {
          const isSelected = selectedTone?.id === tone.id

          return (
            <Styled.ToneOption
              key={tone.id}
              $isSelected={isSelected}
              onClick={() => handleToneSelect(tone)}
              data-tone-id={tone.id}
            >
              <Text type="h4" color="secondarySemiDark" fontWeight={'600'}>
                {tone.name}
              </Text>
            </Styled.ToneOption>
          )
        })}
      </Styled.TonesWrapper>
      <ArrowScrollButton
        direction="right"
        onClick={() => scrollToPosition('right')}
        isVisible={showRightArrow}
      />
    </Styled.ScrollContainer>
  )
}

export default memo(VoiceToneTags)
